"use client";

import { memo, type HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/**
 * Typographie des libellés d'activité de la conversation (réflexion, recherche web,
 * préparation de document, rédaction, vérification) : même taille que le texte des
 * messages, en gris. À combiner avec `Shimmer` tant que l'activité est en cours.
 */
export const ACTIVITY_LABEL_CLASS = "text-base leading-7 font-normal text-muted-foreground";

export interface TextShimmerProps extends Omit<HTMLAttributes<HTMLSpanElement>, "children"> {
  children: string;
}

/**
 * Libellé de chargement animé. Rend le shimmer unique de l'application
 * (`t-shimmer`, src/styles/shimmer.css) pour que réflexion, recherche web,
 * préparation de document et transcription partagent exactement le même rendu.
 */
const ShimmerComponent = ({ children, className, ...props }: TextShimmerProps) => (
  <span {...props} className={cn("t-shimmer", className)} data-text={children}>
    {children}
  </span>
);

export const Shimmer = memo(ShimmerComponent);
